var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outside-scene"},[_c('div',{directives:[{name:"starfield",rawName:"v-starfield"}],staticClass:"starfield"}),_c('div',{staticClass:"wall"})])}
var staticRenderFns = []

export { render, staticRenderFns }